import React, { Component } from 'react'
import { Row, Col, Table, Button, Modal, Spin, Card, Popconfirm, Pagination, Select, Checkbox } from 'antd'
import PropTypes from 'prop-types'
import _ from "underscore"
import { api, app, config } from "../../app"
import utils from "../../utils"
import common from "./common"
import ReviewSearch from "../../components/ReviewSearch"

const Option = Select.Option

/**
 * 判断审核
 * @param audit
 * @returns {string}
 */
function checkAudit (audit) {
    switch (audit) {
        case "0":
            return "未审核"
        case "1":
            return "已通过"
        case "2":
            return "不通过"
    }
}

class ReTrainList extends Component {
    constructor (props) {
        super(props)
        this.state = {
            detailInfo: {},
            train_id: '',
            reviewInfo: {},
            selectedRowKeys: [],
            auditList: [],
            total: 0,
            page: 1,
            dataLevel: '0',
            dataType: '1',
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 关闭详情
     */
    closeDetailModal = () => {
        this.setData({ detail_visible: false, detail_loading: false, detailInfo: {}, train_id: '' })
    }

    /**
     * 打开详情
     */
    openDetailModal = async (train_id) => {
        await this.setData({ train_id, detail_visible: true, detail_loading: true })
        const params = {
            train_id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.PublishTrainDetails, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = {}
        }
        await this.setData({ detailInfo: data, detail_loading: false })
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].train_id).join(',')
        let reviewInfo = {
            id,
            uri: api.PublishTrainAudit,
            id_key: "train_id",
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            this.props.successReview(1, "", reviewInfo)
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 数据加载
     * @param page
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { dataType, search_type, search_val, dataLevel } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            level: dataLevel,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.TrainAuditList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    render () {
        let { data_loading, detail_loading, detail_visible, detailInfo, auditList, total, page, dataType, selectedRowKeys } = this.state,
            tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let columns = [
            {
                title: '标题',
                dataIndex: 'trainame',
                key: 'trainame',
                width: '15%',
                render: (title) => (
                    <span title={title}>{title.length > 20 ? title.substr(0, 20) + '...' : title}</span>)
            },
            {
                title: '培训级别',
                dataIndex: 'object',
                key: 'object',
                width: '10%'
            },
            {
                title: '培训师',
                dataIndex: 'train_teacher',
                key: 'train_teacher',
                width: '10%'
            },
            {
                title: '发布时间',
                dataIndex: 'create_time',
                key: 'create_time',
                width: '15%'
            },
            {
                title: '发布人',
                dataIndex: 'vname',
                key: 'vname',
                width: '10%'
            },
            {
                title: '一级审核',
                dataIndex: 'one_audit',
                key: 'one_audit',
                width: '10%',
                render: (audit, { one_indexno, one_time, detail }) => common.tableStatus(audit, one_indexno, one_time, detail)
            },
            {
                title: '二级审核',
                dataIndex: 'two_audit',
                key: 'two_audit',
                width: '10%',
                render: (audit, { two_indexno, two_time, detail, object }) => {
                    if (object === '全国') {
                        return common.tableStatus(audit, two_indexno, two_time, detail)
                    } else {
                        return (<span>无</span>)
                    }
                }
            },
            {
                title: '三级审核',
                dataIndex: 'three_audit',
                key: 'three_audit',
                width: '10%',
                render: (audit, { three_indexno, three_time, detail, object }) => {
                    if (object === '全国') {
                        return common.tableStatus(audit, three_indexno, three_time, detail)
                    } else {
                        return (<span>无</span>)
                    }
                }
            }
        ], rowSelection = null
        if (dataType === '1') {
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
            columns.push({
                title: '操作',
                dataIndex: 'train_id',
                key: 'train_id',
                width: '10%',
                render: (id) => {
                    let reviewInfo = {
                        id,
                        uri: api.PublishTrainAudit,
                        id_key: "train_id",
                        source: () => this.dataSource(tp),
                    }
                    let disabled = selectedRowKeys.length > 1
                    return (
                        <div>
                            <div>
                                <Button size="small" type="primary" onClick={() => this.openDetailModal(id)}>详情</Button>
                            </div>
                            <div>
                                <Popconfirm placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={() => {
                                                this.props.successReview(1, "", reviewInfo)
                                            }}
                                >
                                    <Button size="small" type="primary" style={{ margin: '10px 0' }}>通过</Button>
                                </Popconfirm>
                            </div>
                            <div>
                                <Button size="small" type="danger" onClick={() => this.props.failReview(reviewInfo)}
                                        disabled={disabled} ghost>不通过</Button>
                            </div>
                        </div>
                    )
                }
            })
        } else {
            columns.push({
                title: '操作',
                dataIndex: 'train_id',
                key: 'train_id',
                width: '10%',
                render: (id) => {
                    return (
                        <Button size="small" type="primary" onClick={() => this.openDetailModal(id)}>详情</Button>
                    )
                }
            })
        }
        return (
            <div className="review-train-list">
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <span style={{ marginLeft: 20 }}>级别选择： </span>
                    <Select defaultValue="0" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataLevel: value })
                        await this.dataSource()
                    }}>
                        <Option value="0">全部</Option>
                        <Option value="1">全国</Option>
                        <Option value="2">省级</Option>
                        <Option value="3">市级</Option>
                        <Option value="4">队伍</Option>
                    </Select>
                    <ReviewSearch type='message' onSearch={this.handleSearch}/>
                </div>
                <Table columns={columns}
                       loading={data_loading}
                       locale={app.tbLocale(data_loading)}
                       dataSource={auditList}
                       scroll={{ y: 'calc(100% - 103px)' }}
                       style={{ height: 'calc(100% - 52px)' }}
                       pagination={false}
                       rowSelection={rowSelection}
                       footer={() => {
                           return (
                               <Row hidden={auditList.length === 0}>
                                   <Col span={10}>
                                       <div hidden={dataType === '2'}>
                                           <Checkbox
                                               checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                               onChange={this.handleAllSel}>全选</Checkbox>
                                           <Button style={{ margin: '0 20px' }} type="primary"
                                                   onClick={() => this.handlePLReview(1)}>通过</Button>
                                           <Button type="danger"
                                                   onClick={() => this.handlePLReview(2)}>不通过</Button>
                                       </div>
                                   </Col>
                                   <Col span={14} style={{ textAlign: 'right' }}>
                                       <Pagination total={total} size="small" pageSize={20} current={page}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handlePageChange}/>
                                   </Col>
                               </Row>
                           )
                       }}
                       size="small"
                />
                {/*培训详情对话框*/}
                <Modal
                    visible={detail_visible}
                    onCancel={this.closeDetailModal}
                    footer={
                        <Button onClick={() => this.closeDetailModal()}>取消</Button>
                    }
                    width={800}
                    zIndex={1000}
                    title={<div style={{ textAlign: "center" }}>培训详情</div>}
                    className="notice-train-list-detail"
                >
                    {
                        detail_loading ? (<Spin/>) : (
                            <div className="items">
                                <div className="braft-output-content" dangerouslySetInnerHTML={{ __html: detailInfo.train_content }} style={{padding: '20px 0'}}/>
                                <Row className="item">
                                    <Col span={4} className="title">培训课程：</Col>
                                    <Col span={19} offset={1}>{detailInfo.trainame}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训级别：</Col>
                                    <Col span={19} offset={1}>
                                        {detailInfo.object === "1" ? "全国" : (detailInfo.object === "2" ? "省级" : (detailInfo.object === "3" ? "市级" : "队伍"))}
                                    </Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训师：</Col>
                                    <Col span={19} offset={1}>{detailInfo.train_teacher}</Col>
                                </Row>
                                {
                                    detailInfo.is_class === '1' ? (
                                        <Row className="item">
                                            <Col span={4} className="title">培训周期：</Col>
                                            <Col span={19}
                                                 offset={1}>{detailInfo.train_day}天</Col>
                                        </Row>
                                    ) : (
                                        <Row className="item">
                                            <Col span={4} className="title">培训时间：</Col>
                                            <Col span={19}
                                                 offset={1}>{detailInfo.startdate + ' ~ ' + detailInfo.endate}</Col>
                                        </Row>
                                    )
                                }
                                <Row className="item">
                                    <Col span={4} className="title">报名截止时间：</Col>
                                    <Col span={19} offset={1}>{detailInfo.apply_time}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训价格：</Col>
                                    <Col span={19}
                                         offset={1}>{parseFloat(detailInfo.train_price).toFixed(2)}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训人数：</Col>
                                    <Col span={19} offset={1}>{detailInfo.train_number}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训地点：</Col>
                                    <Col span={19} offset={1}>{detailInfo.train_site}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训级别：</Col>
                                    <Col span={19} offset={1}>{detailInfo.grade}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训装备：</Col>
                                    <Col span={19} offset={1}>{detailInfo.train_equip || '无'}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">培训技能：</Col>
                                    <Col span={19} offset={1}>{detailInfo.train_ppe || '无'}</Col>
                                </Row>
                                <Row className="item">
                                    <Col span={4} className="title">审核情况：</Col>
                                    <Col span={19} offset={1}>
                                        <Card bodyStyle={{ padding: 12 }} className="item-card"
                                              title={"一级审核"}>
                                            <div>
                                                <div>审核人：{detailInfo.one_indexno}</div>
                                                <div>审核状态：{checkAudit(detailInfo.one_audit)}</div>
                                                <div>审核时间：{detailInfo.one_time || "无"}</div>
                                                {detailInfo.one_audit === "2" ?
                                                    <div>不通过原因：{detailInfo.audit_reason}</div> : null}
                                            </div>
                                        </Card>
                                        {
                                            detailInfo.object === "1" ?
                                                [
                                                    (<Card key="1" bodyStyle={{ padding: 10 }}
                                                           className="item-card"
                                                           title={"二级审核"}>
                                                        {
                                                            detailInfo.two_indexno ?
                                                                (
                                                                    <div>
                                                                        <div>审核人：{detailInfo.two_indexno}</div>
                                                                        <div>审核状态：{checkAudit(detailInfo.two_audit)}</div>
                                                                        <div>审核时间：{detailInfo.two_time || "无"}</div>
                                                                        {detailInfo.two_audit === "2" ?
                                                                            <div>不通过原因：{detailInfo.audit_reason}</div> : null}
                                                                    </div>
                                                                ) : "暂无审核"
                                                        }
                                                    </Card>),
                                                    (<Card key="2" bodyStyle={{ padding: 10 }}
                                                           className="item-card"
                                                           title={"三级审核"}>
                                                        {
                                                            detailInfo.three_indexno ?
                                                                (
                                                                    <div>
                                                                        <div>审核人：{detailInfo.three_indexno}</div>
                                                                        <div>审核状态：{checkAudit(detailInfo.three_audit)}</div>
                                                                        <div>审核时间：{detailInfo.three_time || "无"}</div>
                                                                        {detailInfo.three_audit === "2" ?
                                                                            <div>不通过原因：{detailInfo.audit_reason}</div> : null}
                                                                    </div>
                                                                ) : "暂无审核"
                                                        }
                                                    </Card>)
                                                ] : null
                                        }
                                    </Col>
                                </Row>
                                <Row className="item">
                                    <Col>
                                        {
                                            (detailInfo.details_images || []).map((img, index) => {
                                                return (<img key={index} src={config.imgUrl + img} alt=""
                                                             className="d-img"/>)
                                            })
                                        }
                                    </Col>
                                </Row>
                            </div>
                        )
                    }
                </Modal>
            </div>
        )
    }
}

ReTrainList.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReTrainList



// WEBPACK FOOTER //
// ./src/routes/review/ReReleaseTrain.jsx